module.exports = __webpack_public_path__ + "public/img/img_pixeltex_hk.22549194.png";